"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierTypesEnum = void 0;
var SupplierTypesEnum;
(function (SupplierTypesEnum) {
    SupplierTypesEnum["PARTNER"] = "partner";
    SupplierTypesEnum["BRAND"] = "brand";
    SupplierTypesEnum["CUSTOMER"] = "customer";
    SupplierTypesEnum["GID"] = "gid";
    SupplierTypesEnum["ALREADY_SUPPLIED"] = "already_supplied";
})(SupplierTypesEnum = exports.SupplierTypesEnum || (exports.SupplierTypesEnum = {}));
//# sourceMappingURL=supplier-types-enum.js.map